import React from "react";
import { motion } from "framer-motion";

const defaultTransition = { duration: 0.55, ease: [0.22, 1, 0.36, 1] };

export default function FadeInView({
  children,
  className,
  delay = 0,
  y = 20,
  as: Tag = motion.div,
  ...props
}) {
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ ...defaultTransition, delay }}
      {...props}
    >
      {children}
    </Tag>
  );
}
